<template>
  <div class="banner-wrapper" :class="{loggedIn: isLoggedIn}">
      <span class="adjusted-texts" v-if="!isLoggedIn">
      <h2>{{ t('Banner_Become_Trader_H3') }}</h2>
      <h3>{{ t('Banner_Become_Trader_Sub_Title') }}</h3>
      <button @click="toSignupPlatform">
        {{ t('Banner_Become_Trader_Btn_Txt') }}</button>
      </span>
      <span class="adjusted-texts" v-else>
        <h2>{{ t('Banner_Welcome_Back_H3') }}</h2>
      <h3>{{t('Banner_Welcome_Back_Sub_Title')}}</h3>
      <button @click="toPlatform">
        {{ t("Button_Trade_Now") }}
      </button>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AlvexoBanner",
  props: ["isLoggedIn"],
  computed: {
    ...mapGetters(["t", "userLoginLink", "userSignupLink"])
  },
  methods: {
    toPlatform: function() {
      window.location.href = this.userLoginLink;
    },
    toSignupPlatform: function() {
      window.location.href = this.userSignupLink;
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-wrapper,
.banner-wrapper .adjusted-texts {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-wrapper {
  background-image: url("../assets/images/components/alvexo_banner/banner_bg_desktop.jpg");
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 50px 30px;


  h2 {
    font-weight: bold;
    font-size: 58px;
    text-align: center;
    line-height: 1.3;
  }

  h3 {
    font-size: 38px;
    font-weight: normal;
    text-align: center;
    line-height: 1.3;
  }

  button {
    margin-top: 30px;
    min-width: 260px;
    max-width: 400px;
    padding: 9px 20px;
    background: #85c446;
    text-align: center;
    font-size: 22px;
    color: #fff;
    border: none;
    outline: none;
    box-shadow: none;
    border-radius: 3px;

    &:hover {
      cursor: pointer;
      background: #a2de66;
    }
    &:focus {
      outline: none;
    }
  }

  .risk {
    font-size: 12px;
  }

  @media only screen and (max-width: 991px) {
    h2 {
      font-size: 48px;
    }
    h3 {
      font-size: 22px;
    }
    button {
      font-size: 20px;
      width: 200px;
    }
    .risk {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 479px) {
    .banner-wrapper {
      background-image: url("../assets/images/components/alvexo_banner/banner_bg_mobile.jpg");
      background-size: cover;
    }

    h2 {
      font-size: 28px;
    }
    h3 {
      font-size: 18px;
    }
  }
}
</style>